export const types = {
    OPEN: 'OPEN',
    INSDELROW: 'INSERT-DELETE-ROW',
    INSDELCOL: 'INSERT-DELETE-COLUMN',
    COPY: 'COPY',
    PASTE: 'PASTE',
    PIVOT: 'CREATE-PIVOT',
    EXPORTCSV: 'EXPORT-TO-CSV',
    WRITECELL: 'WRITE-CELL',
    VLOOKUP: 'VLOOKUP',
    READSHEET: 'READ-SHEET',
    READFILE: 'READ-FILE',
    SAVE: 'SAVE',
    SETCELLFORMULA: 'SET-CELL-FORMULA',
    RUNMACRO: 'RUN-MACRO',
    WRITERANGE: 'WRITE-RANGE',
    NEWFILE: 'NEW-FILE',
    SEARCH: 'SEARCH',
    DELETECELL: 'DELETE-CELL',
    FILTER: "FILTER",
    FIND: "FIND"
};
